// extracted by mini-css-extract-plugin
export default {"LeftPanel":"styles_LeftPanel__X3R72","hide":"styles_hide__7IRcI","header":"styles_header__uK+Kq","hideButton":"styles_hideButton__Yct0t","container":"styles_container__RIQSC"};